import { render } from "./CxSlopeMapLegend.vue?vue&type=template&id=ff885598"
import script from "./CxSlopeMapLegend.vue?vue&type=script&lang=js"
export * from "./CxSlopeMapLegend.vue?vue&type=script&lang=js"

import exportComponent from "/home/ec2-user/workspace/_ui2_staging_ui2-staging-0.124.0/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__